import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/")({
  component: lazyRouteComponent(() => import("./+Profile")),
  head: () => ({
    meta: seo({ title: "Profile" }),
  }),
});
